import { DevTool } from '@hookform/devtools';
import { yupResolver } from '@hookform/resolvers/yup';
import { Button, Card, Chip, CircularProgress, FormHelperText, Grid, IconButton, Modal, TextField, Typography } from '@mui/material';
import { Box, Stack } from '@mui/system';
import PropTypes from 'prop-types';
import React, { useState } from 'react';
import { useForm } from 'react-hook-form';
import { useDispatch, useSelector } from 'react-redux';
import * as yup from "yup";
import SnackBarUI from '../../../comman/SnackBarUI';
import AddCircleIcon from '@mui/icons-material/AddCircle';
import { createFAQAction } from '../../../redux/toolkit/publisher/support/createFAQ';
import { getFAQAction } from '../../../redux/toolkit/publisher/support/getFAQs';



// schema
const catSchema = yup.object({
    title: yup.string().required('Title is required.'),
}).required();

export default function CreateFAQ({ state, setState }) {
    // state
    const { register, setError, control, handleSubmit, formState: { errors }, reset } = useForm({ resolver: yupResolver(catSchema) });

    const dispatch = useDispatch()
    const createFAQ = useSelector(state => state.createFAQ)
    const { status, message, loading } = createFAQ

    const [ansArr, setAnsArr] = useState([])
    const [snack, setSnack] = useState(false)
    const [answerOption, setAnswerOption] = useState('')


    // fn
    const handleDelAnsOpt = (i) => {
        setAnsArr((current) => current.filter((chips, index) => { return index !== i; }))
        setAnswerOption('')
    }

    const handleFAQ = async (data) => {

        if (!ansArr.length) {
            return setError('ansOps', { type: 'custom', message: 'Answer option can not be empty.' });
        }
        const createFAQData = await dispatch(createFAQAction({ ...data, answers: ansArr, }))
        if (createFAQData?.payload?.status == 201) {
            setAnsArr([])
            dispatch(getFAQAction({ is_deleted: '' }))
        }
        setSnack(true)
        setState(false)
        reset()
    }

    const handleAddAnsOpt = () => {
        const foundDuplicate = ansArr.find(element => element == answerOption);
        if (foundDuplicate !== undefined) return
        setAnsArr(prev => [...prev, answerOption])
        setAnswerOption('')
    }

    const handleClose = function () {
        setState(false)
    }


    return (
        <>
            <Modal sx={{ overflow: 'scroll' }} open={state} onClose={handleClose}>
                <Box className='modal_box'>
                    <Card sx={{ width: 900, p: 5 }}>
                        <Typography variant='h5' sx={{ mb: 5 }} align='center'>Create FAQ</Typography>
                        <form onSubmit={handleSubmit(handleFAQ)}>
                            <Stack spacing={3}>
                                <TextField type='text' label="FAQ" variant="outlined" placeholder='Title' {...register('title')} error={errors?.title?.message} helperText={errors?.title?.message} />

                                <Grid container columnSpacing={1}>
                                    <Grid item xs={10}>
                                        <TextField value={answerOption} onChange={(event) => setAnswerOption(event.target.value)} fullWidth label="Answer Options" variant="outlined" placeholder='Answer Options' />
                                    </Grid>

                                    <Grid item xs={1}>
                                        <IconButton disabled={!answerOption} color='primary' onClick={handleAddAnsOpt} ><AddCircleIcon fontSize='large' /></IconButton>
                                    </Grid>
                                </Grid>
                                <FormHelperText error={errors?.ansOps?.message}>{errors?.ansOps?.message}</FormHelperText>

                                <Stack spacing={1}>
                                    {ansArr.map((items, index) => {
                                        return (
                                            <Stack direction='row' spacing={2} key={index}>
                                                <Chip variant="outlined" key={index} label={items} onDelete={() => handleDelAnsOpt(index)} />
                                            </Stack>
                                        )
                                    })}
                                </Stack>

                                <Stack direction='row' spacing={2}>
                                    <Button variant='contained' type='submit' disabled={loading}>{loading ? <CircularProgress /> : 'Create FAQ'}</Button>
                                    <Button variant='contained' color='error' onClick={handleClose}>Close</Button>
                                </Stack>
                            </Stack>
                        </form>
                    </Card>
                </Box>
            </Modal>
            <SnackBarUI state={snack} setState={setSnack} status={status} message={message} />
            <DevTool control={control} />
        </>
    )
}



CreateFAQ.propTypes = {
    state: PropTypes.any,
    setState: PropTypes.any
};